/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class GeneratedAdminService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation changeUserEmail
   */
  static readonly ChangeUserEmailPath = '/api/admin/users/change-email';

  /**
   * Changes the sign-in and contact email address of an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeUserEmail()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  changeUserEmail$Response(params?: {
    'X-API-Version'?: string;
    body?: {
'userId': number;
'email': string;
'sendConfirmationMail': boolean;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.ChangeUserEmailPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Changes the sign-in and contact email address of an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeUserEmail$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  changeUserEmail(params?: {
    'X-API-Version'?: string;
    body?: {
'userId': number;
'email': string;
'sendConfirmationMail': boolean;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.changeUserEmail$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation reassignBidder
   */
  static readonly ReassignBidderPath = '/api/admin/bidders/reassign';

  /**
   * Assigns an existing bidder to another user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reassignBidder()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reassignBidder$Response(params?: {
    'X-API-Version'?: string;
    body?: {
'bidderId': number;
'userId': number;
'makeBidderPrimary': boolean;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.ReassignBidderPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Assigns an existing bidder to another user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reassignBidder$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  reassignBidder(params?: {
    'X-API-Version'?: string;
    body?: {
'bidderId': number;
'userId': number;
'makeBidderPrimary': boolean;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.reassignBidder$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation mergeUsers
   */
  static readonly MergeUsersPath = '/api/admin/users/merge';

  /**
   * Moves most of the source users data onto the target user, and deletes the source user afterwards.
   *
   * Note that on merge some data, like verifications and documents, will not get merged and get deleted instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mergeUsers()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mergeUsers$Response(params?: {
    'X-API-Version'?: string;
    body?: {
'sourceUserId': number;
'targetUserId': number;
'newInumisId': string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.MergeUsersPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Moves most of the source users data onto the target user, and deletes the source user afterwards.
   *
   * Note that on merge some data, like verifications and documents, will not get merged and get deleted instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mergeUsers$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  mergeUsers(params?: {
    'X-API-Version'?: string;
    body?: {
'sourceUserId': number;
'targetUserId': number;
'newInumisId': string;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.mergeUsers$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation retrieveSixbidLotIds
   */
  static readonly RetrieveSixbidLotIdsPath = '/api/admin/retrievelotids/{auctionCatalogPartId}';

  /**
   * Retrieves the sixbid lot id for a given auction catalog part id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retrieveSixbidLotIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveSixbidLotIds$Response(params: {
    auctionCatalogPartId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.RetrieveSixbidLotIdsPath, 'get');
    if (params) {
      rb.path('auctionCatalogPartId', params.auctionCatalogPartId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Retrieves the sixbid lot id for a given auction catalog part id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retrieveSixbidLotIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retrieveSixbidLotIds(params: {
    auctionCatalogPartId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.retrieveSixbidLotIds$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation enqueueAcceptedBidsForSixbidSync
   */
  static readonly EnqueueAcceptedBidsForSixbidSyncPath = '/api/admin/enqueueacceptedBidIds/{auctionId}';

  /**
   * Enqueue all accepted bids for SixbidSync.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enqueueAcceptedBidsForSixbidSync()` instead.
   *
   * This method doesn't expect any request body.
   */
  enqueueAcceptedBidsForSixbidSync$Response(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.EnqueueAcceptedBidsForSixbidSyncPath, 'get');
    if (params) {
      rb.path('auctionId', params.auctionId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Enqueue all accepted bids for SixbidSync.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enqueueAcceptedBidsForSixbidSync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enqueueAcceptedBidsForSixbidSync(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.enqueueAcceptedBidsForSixbidSync$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteBidder
   */
  static readonly DeleteBidderPath = '/api/admin/bidders/delete';

  /**
   * Deletes an existing bidder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBidder()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  deleteBidder$Response(params?: {
    'X-API-Version'?: string;
    body?: {
'bidderId': number;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.DeleteBidderPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes an existing bidder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBidder$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  deleteBidder(params?: {
    'X-API-Version'?: string;
    body?: {
'bidderId': number;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteBidder$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation createBiddersForAuction
   */
  static readonly CreateBiddersForAuctionPath = '/api/admin/bidders/createBiddersForAuction';

  /**
   * Creates bidders for an auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBiddersForAuction()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createBiddersForAuction$Response(params?: {
    'X-API-Version'?: string;
    body?: {
'auctionId': number;
'userId': number;
'bidderNumberFrom': number;
'bidderNumberTo': number;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedAdminService.CreateBiddersForAuctionPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Creates bidders for an auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBiddersForAuction$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createBiddersForAuction(params?: {
    'X-API-Version'?: string;
    body?: {
'auctionId': number;
'userId': number;
'bidderNumberFrom': number;
'bidderNumberTo': number;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.createBiddersForAuction$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
